import {
  ColumnChooser,
  ColumnDirective,
  ColumnMenu,
  ColumnsDirective,
  Edit,
  EditSettingsModel,
  ExcelExport,
  Filter,
  FilterSettingsModel,
  GridComponent,
  Group,
  Inject,
  Page,
  PageSettingsModel,
  Resize,
  Toolbar,
} from '@syncfusion/ej2-react-grids';
import React, { Component } from 'react';
import Message from '../../../utils/Message/Message';
import { all_information, loadingShow } from '../../../App';
import { AddEventStatus, DeleteEventStatus, EditEventStatus, getEventStatus } from '../../../services/EventStatus/EventStatusServices';
interface IState {
  EventStatusData: any;
}
interface IProps { }
export class EventStatus extends Component<IProps, IState> {
  private gridEventStatusObj: any;
  public validationRule: Object = { required: true };
  constructor(prop: IProps) {
    super(prop);
    this.state = {
      EventStatusData: [],
    };
  }
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  public toolbarOptions = [
    'Add',
    'Edit',
    'Delete',
    'Update',
    'Cancel',
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-refresh',
      id: 'refresh',
    },
    'ColumnChooser',
    'ExcelExport',
    'Search',
  ];
  public editOptions: EditSettingsModel = {
    allowAdding: true,
    allowDeleting: true,
    allowEditing: true,
  };
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 12,
    pageCount: 8,
    pageSizes: true,
  };
  toolbarClick(args: any) {
    if (args.item.id === 'refresh') {
      this.getEventStatus();
    }
    if (
      this.gridEventStatusObj &&
      args.item.id === 'gridEventStatus_excelexport'
    ) {
      this.gridEventStatusObj.excelExport();
    }
  }
  getEventStatus() {
    getEventStatus().then((res) => {
      this.setState({ EventStatusData: res.data });
    });
  }
  componentDidMount() {
    this.getEventStatus();
  }
  SavePointAdd(data: any) {
    const obj = {
      organizationId: all_information.company_id?.toString(),
      createdBy: all_information.user_id,
      statusCode: data.statusCode,
      statusDescription: data.statusDescription,
      statusAlias: data.statusAlias,
    };
    AddEventStatus(obj)
      .then((res: any) => {
        Message.success('Success');
        loadingShow(false);
        this.getEventStatus();
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
            '\n' +
            err.response.status +
            '\n' +
            err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  SavePointEdit(data: any) {
    const obj = {
      organizationId: all_information.company_id?.toString(),
      createdBy: all_information.user_id,
      statusCode: data.statusCode,
      statusDescription: data.statusDescription,
      statusAlias: data.statusAlias,
      id: data.id,
    };
    EditEventStatus(obj)
      .then((res: any) => {
        Message.success('Success');
        loadingShow(false);
        this.getEventStatus();
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
            '\n' +
            err.response.status +
            '\n' +
            err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  deletePoint(obje: any) {
    const obj = JSON.stringify({
      id: obje[0].id,
    });
    DeleteEventStatus(obj)
      .then((res: any) => {
        Message.success('Success');
        loadingShow(false);
        this.getEventStatus();
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
            '\n' +
            err.response.status +
            '\n' +
            err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  actionBeginEventStatus(args: any) {
    if (args.action === 'add') {
      this.SavePointAdd(args.data);
    } else if (args.action === 'edit') {
      this.SavePointEdit(args.data);
    } else if (args.requestType === 'delete') {
      this.deletePoint(args.data);
    }
  }
  render() {
    return (
      <div>
        <GridComponent
          id='gridEventStatus'
          editSettings={this.editOptions}
          toolbar={this.toolbarOptions}
          dataSource={this.state.EventStatusData}
          height='calc(-220px + 100vh)'
          ref={(g) => (this.gridEventStatusObj = g)}
          filterSettings={this.FilterOptions}
          allowFiltering={true}
          allowPaging={true}
          pageSettings={this.pageOptions}
          showColumnMenu={true}
          allowResizing={true}
          allowGrouping={true}
          allowExcelExport={true}
          showColumnChooser
          toolbarClick={this.toolbarClick.bind(this)}
          actionBegin={this.actionBeginEventStatus.bind(this)}
          gridLines='Both'
        >
          <ColumnsDirective>
            <ColumnDirective
              field='statusCode'
              headerText='Event Status Code'
              textAlign='Left'
              validationRules={this.validationRule}
            />
            <ColumnDirective
              field='statusDescription'
              headerText='Event Status Description'
              textAlign='Left'
              validationRules={this.validationRule}
            />
            <ColumnDirective
              field='statusAlias'
              headerText='Event Status Alias'
              textAlign='Left'
              validationRules={this.validationRule}
            />
          </ColumnsDirective>
          <Inject
            services={[
              Edit,
              Toolbar,
              Filter,
              Page,
              ColumnChooser,
              ExcelExport,
              ColumnMenu,
              Resize,
              Group,
            ]}
          />
        </GridComponent>
      </div>
    );
  }
}
export default EventStatus;
